module.exports = __webpack_public_path__ + "img/9788920037283.a82b2b59.jpg";